/** Prefix of every IndexedDB database the removed client-side race-card cache created. */
export const LEGACY_RACE_CACHE_DB_PREFIX = 'pmu-race-cache:';

/**
 * One-time cleanup of the removed client-side race-card cache: deletes the
 * IndexedDB databases earlier versions stored race days in. Best-effort: never
 * throws, no-op where IndexedDB is unavailable.
 *
 * TODO remove after 2 releases (target: end of 2026-11), once devices have purged.
 */
export function purgeLegacyRaceCache(tenant: string | undefined, env: string | undefined, idb: IDBFactory | undefined = globalThis.indexedDB): void {
  if (!idb) {
    return;
  }
  const base = `${LEGACY_RACE_CACHE_DB_PREFIX}${tenant || 'default'}:${env || 'dev'}`;
  [`${base}:live`, `${base}:cache`].forEach(name => safeDelete(idb, name));

  if (typeof idb.databases === 'function') {
    idb.databases()
      .then(dbs => dbs
        .map(db => db.name)
        .filter((name): name is string => !!name && name.startsWith(LEGACY_RACE_CACHE_DB_PREFIX))
        .forEach(name => safeDelete(idb, name)))
      .catch(() => { /* listing not permitted: the named deletes above still ran */ });
  }
}

function safeDelete(idb: IDBFactory, name: string): void {
  try {
    idb.deleteDatabase(name);
  } catch {
    /* nothing to clean up */
  }
}
